module.exports = __webpack_public_path__ + "img/title.49df2552.png";